import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url';

export const sanityClient = createClient({
    projectId: 'xkkpkblt',
    dataset: 'production',
    apiVersion: '2025-04-14',
    useCdn: false, // Disable CDN to use the secure API endpoint
})
  

const builder = imageUrlBuilder(sanityClient);

export const urlFor = (source: any) => builder.image(source);

export const getVideoUrl = (source: any): string | null => {
    if (!source?.asset?._ref) return null;
  
    const [_, id, ext] = source.asset._ref.split('-'); // e.g. file-abc123-mp4
    return `https://cdn.sanity.io/files/${sanityClient.config().projectId}/${sanityClient.config().dataset}/${id}.${ext}`;
};